import React, { useCallback, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { logoutRequest } from '../api/authApi';
import { AuthContext } from '../contexts/AuthContext';
import { Button, Modal } from "antd";

export const useLogout = () => {
    const { logout } = useContext(AuthContext);
    const navigate = useNavigate();

    const performLogout = useCallback(() => {
        return logoutRequest()
            .then(() => {
                logout();
                navigate("/");
            })
            .catch(() => {
                logout();
                navigate("/");
            });
    }, [logout, navigate]);

    const confirmLogout = useCallback(() => {
        Modal.confirm({
            title: "Da li ste sigurni da želite da se odjavite?",
            okText: "Potvrdi",
            cancelText: "Odustani",
            onOk: performLogout,
        });
    }, [performLogout]);

    return { performLogout, confirmLogout };
};

const LogOut = () => {
    const { confirmLogout } = useLogout();

    return (
        <Button type="primary" onClick={confirmLogout}>
            Odjava
        </Button>
    );
};

export default LogOut;
